import NoStatus from 'assets/Images/noStatus.svg'
import PendingCheckOut from 'assets/Images/pendignCheckout.svg'
import DropInIco from 'assets/Images/dropIn.svg'
import CheckedOut from 'assets/Images/checkedOut.svg'
import CheckedIn from 'assets/Images/checkedIn.svg'

export const StatusList: any = [
  {
    key: 1,
    value: 'no-status',
    title: 'No status',
    img: NoStatus,
    color: '#F6F7F8',
  },
  {
    key: 2,
    value: 'droped-in',
    title: 'Dropped-in',
    img: DropInIco,
    color: '#E8E9F7',
  },
  {
    key: 3,
    value: 'dropped-out',
    title: 'Dropped-out',
    img: DropInIco,
    color: '#E8E9F7',
  },
  {
    key: 4,
    value: 'checked-in',
    title: 'Checked in',
    img: CheckedIn,
    color: '#F1F8E7',
  },
  {
    key: 5,
    value: 'checked-out',
    title: 'Checked out',
    img: CheckedOut,
    color: '#FFE2E0',
  },
  {
    key: 6,
    value: 'request-check-out',
    // title: 'Request Check-out',
    title: 'Check-out pending',
    img: PendingCheckOut,
    color: '#FEF4E8',
  },
  {
    key: 7,
    value: 'pending',
    title: 'Pending',
    img: PendingCheckOut,
    color: '#FEF4E8',
  },
  {
    key: 8,
    value: 'request-check-in',
    // title: 'Request Check-in',
    title: 'Check-in pending',
    img: PendingCheckOut,
    color: '#FEF4E8',
  },
]
